<template>
	<div class="snowWrap">
		<div
				v-for="n in currentFlakesCount"
				:key="n"
				class="snow"
		></div>
	</div>
</template>

<script>
export default {
	name: 'SnowWrap',
	props: {
		// сколько снежинок на десктопе
		flakesDesktop: {
			type: Number,
			default: 200
		},
		// сколько снежинок на мобильных
		flakesMobile: {
			type: Number,
			default: 80
		},
		// ширина, ниже которой считаем устройство мобильным
		mobileBreakpoint: {
			type: Number,
			default: 768
		}
	},
	data() {
		return {
			isMobile: false
		};
	},
	computed: {
		currentFlakesCount() {
			const maxFlakes = 200; // должен совпадать с $snow-total в SCSS
			const target = this.isMobile ? this.flakesMobile : this.flakesDesktop;
			return Math.min(target, maxFlakes);
		}
	},
	mounted() {
		this.checkIsMobile();
		window.addEventListener('resize', this.checkIsMobile);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.checkIsMobile);
	},
	methods: {
		checkIsMobile() {
			if (typeof window === 'undefined') return;
			this.isMobile = window.innerWidth <= this.mobileBreakpoint;
		}
	}
};
</script>

<style scoped lang="scss">
$snow-total: 200;

@function random_range($min, $max) {
	$rand: random();
	$random_range: $min + floor($rand * (($max - $min) + 1));
	@return $random_range;
}

.snowWrap {
	position: absolute;
	z-index: 1;
	overflow: hidden;
	width: 100%;
	height: 100%;
	display: block;
	top: 0;
	left: 0;
}

.snow {
	position: absolute;
	width: 10px;
	height: 10px;
	border-radius: 50%;

	// базовый цвет (перекроется var'ом, если задан)
	background: rgba(255, 255, 255, 0.15);
	background: var(--card-table-body-bg-hover);
}

// генерим стили и анимации для каждой снежинки
@for $i from 1 through $snow-total {
	$random-x:          random(1000000) * 0.0001vw;
	$random-offset:     random_range(-100000, 100000) * 0.0001vw;
	$random-x-end:      $random-x + $random-offset;
	$random-x-end-yoyo: $random-x + ($random-offset / 2);
	$random-yoyo-time:  random_range(30000, 80000) / 100000;
	$random-yoyo-y:     $random-yoyo-time * 100vh;
	$random-scale:      random(10000) * 0.0001;
	$fall-duration:     random_range(10, 30) * 1s;
	$fall-delay:        random(30) * -1s;

	.snow:nth-child(#{$i}) {
		opacity:   random(10000) * 0.0001;
		transform: translate($random-x, -10px) scale($random-scale);
		animation: fall-#{$i} $fall-duration $fall-delay linear infinite;
	}

	@keyframes fall-#{$i} {
		#{percentage($random-yoyo-time)} {
			transform: translate($random-x-end, $random-yoyo-y) scale($random-scale);
		}

		to {
			transform: translate($random-x-end-yoyo, 100vh) scale($random-scale);
		}
	}
}
</style>
